import AppViewRouter from "../../layout/AppRouterView.vue";

const token = sessionStorage.getItem("token");
const role = sessionStorage.getItem("role");

const isAuthBappebti = (to, from, next) => {
    if (token) {
        if (role == 8 || role == 9) {
            next();
        } else {
            next("/history-transaction");
        }
    } else {
        next("/login");
    }
};

const bappebtiRoutes = [
    {
        path: "/history-transaction",
        component: AppViewRouter,
        beforeEnter: isAuthBappebti,
        children: [
            {
                path: "/",
                name: "History-Transaction",
                component: () => import("./page/History.vue"),
            },
            {
                path: "/History-Transaction-Off",
                name: "History-Transaction-Off",
                component: () => import("./page/HistoryOff.vue"),
            },
            {
                path: ":id",
                name: "DetailHistory",
                component: () => import("./page/HistoryDetail.vue"),
            },
            {
                path: "/client",
                name: "Client",
                component: () => import("./page/ClientList.vue"),
            },
            {
                path: "/history-withdraw-off",
                name: "History WIthdraw Off",
                component: () => import("./page/HistoryWithdrawOff.vue"),
            },
            {
                path: "/history-withdraw",
                name: "History WIthdraw",
                component: () => import("./page/HistoryWithdraw.vue"),
            },
            {
                path: "/history-inventory",
                name: "History Inventory",
                component: () => import("./page/Inventory.vue"),
            },
            {
                path: '/participant',
                name: 'Participant',
                component: () => import('./page/ParticipantPage.vue')
            },
            {
                path: "/history-inventory-off",
                name: "History Inventory off",
                component: () => import("./page/InventoryOff.vue"),
            },
            {
                path: "/history-inventory-detail/:id",
                name: "History Inventory Detail",
                component: () => import("./page/InventoryDetail.vue"),
            },
            {
                path: "/history-inventory-detail-off/:id",
                name: "History Inventory Detail Off",
                component: () => import("./page/InventoryDetailOff.vue"),
            },
        ],
    },
];

export default bappebtiRoutes;
